import React from 'react'
import { HeadingText, type HeadingTextProps } from '@paypalcorp/pp-react'

import * as styles from './titleAndStatus.css'
import ClosedBadge from '../../components/ClosedBadge'

interface TitleAndStatusProps {
  text: string
  isClosed: boolean
  headingPropsOverride?: Partial<HeadingTextProps>
}

const TitleAndStatus = (props: TitleAndStatusProps) => (
  <div className={styles.titleContainer}>
    <HeadingText
      className={styles.title}
      data-testid="groupHeading"
      as="h1"
      {...(props.headingPropsOverride ?? {})}
    >
      {props.text}
    </HeadingText>
    {props.isClosed && <ClosedBadge />}
  </div>
)

export default TitleAndStatus
